import React, { useState } from 'react';
import Header from '../Components/Common/Header';
import Footer from '../Components/Common/Footer';
import config from '../config';
import { Helmet } from 'react-helmet-async';
import ReCAPTCHA from 'react-google-recaptcha';

const Contact = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phoneno: '',
        message: ''
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState(null);


    const handleChange = (e) => {
        const { name, value } = e.target;

        // Check for spaces and invalid characters (numeric and special) for first_name and last_name
        const isNameField = name === 'first_name' || name === 'last_name';
        const invalidCharacters = /[^a-zA-Z]/; // Allow only letters

        if (name === 'email' && value.includes(' ')) {
            return;
        }
        if (isNameField) {
            if (value.includes(' ')) {
                return;
            } else if (invalidCharacters.test(value)) {
                return;
            }
        }
        if (name === 'message' && value.startsWith(' ')) {
            return; // Prevent the update if the first character is a space
        }

        // Update the form data for valid inputs
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));

        setErrorMessage(''); // Clear error if the value is valid
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!recaptchaToken) {
            setErrorMessage("Please complete the reCAPTCHA.");
            return;
        }
        // Email validation regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Check if the email is invalid
        if (!emailRegex.test(formData.email)) {
            setErrorMessage("Invalid email format.");
            return; // Stop form submission
        }

        console.log("Submitting Form Data:", formData);

        try {
            const response = await fetch(`${config.baseUrl}/add-contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const responseData = await response.json();
            console.log("API Response:", responseData);

            if (response.ok) {
                setSuccessMessage("Your message has been successfully submitted!");
                setFormData({
                    first_name: '',
                    last_name: '',
                    email: '',
                    phoneno: '',
                    message: ''
                });
                setErrorMessage('');
            } else {
                setErrorMessage(responseData.message || "Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            setErrorMessage("An error occurred. Please try again.");
        }
    };

    return (
        <>
            <Helmet>
                <title>Contact | Corpquick</title>
                <meta name="description" content="Contact us for any inquiries or support. We are here to help you." />
            </Helmet>
            <Header />

            <div className='common-banenr'>
                <div className='common-content'>
                    <h1>Contact<span> Us</span></h1>
                </div>
            </div>
            <div className='banner-bottom-box'>
                <div className='box1'>
                </div>
            </div>

            <section className="contact-us">
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='contact-box'>
                                <div className="icon-contact">
                                    <img src="images/location.png" alt="location" />
                                </div>
                                <p>901 N Pitt Str., Suite 170 Alexandria, USA</p>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='contact-box'>
                                <div className="icon-contact">
                                    <img src="images/contactphone.png" alt="contact phone" />
                                </div>
                                <p><a href="tel:(804) 916-1974">(804) 916-1974</a></p>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='contact-box'>
                                <div className="icon-contact">
                                    <img src="images/clock.png" alt="clock" />
                                </div>
                                <p>Monday – Saturday: 8AM – 6PM<br />Sunday: OFF DAY</p>
                            </div>
                        </div>
                    </div>
                    <div className='row  form-sec'>
                        <div className='col-md-6'>
                            <div className='contact-form' >
                                <div className='form-contact'>
                                    <h4>Get In Touch With Us</h4>
                                    <form onSubmit={handleSubmit}>
                                        <input
                                            type="text"
                                            name="first_name"
                                            placeholder="First Name"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <input
                                            type="text"
                                            name="last_name"
                                            placeholder="Last Name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <input
                                            type="text"
                                            name="email"
                                            placeholder="Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            onBlur={(e) => {
                                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                                if (!emailRegex.test(e.target.value)) {
                                                    setErrorMessage("Invalid email format.");
                                                } else {
                                                    setErrorMessage("");
                                                }
                                            }}
                                        />


                                        <input
                                            type="text" // Change to text to allow length validation
                                            name="phoneno"
                                            placeholder="Phone"
                                            value={formData.phoneno}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                                if (value.length <= 15) {
                                                    setFormData({ ...formData, phoneno: value });
                                                }
                                            }}
                                            required
                                            pattern="^\d{10,15}$" // Ensures 10-15 digits
                                        />
                                        <textarea
                                            name="message"
                                            placeholder='Message'
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <ReCAPTCHA
                                            sitekey="6LdiaSArAAAAAD_c-uNdevz2FRZbT1wducb3S5BX"
                                            // below key is for testing
                                            // sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" 
                                            onChange={(token) => setRecaptchaToken(token)}
                                        />

                                        <input type="submit" value="Submit" />
                                    </form>
                                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                                    {successMessage && <p className="success-message">{successMessage}</p>}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='ifram'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3108.801591474291!2d-77.04484742487185!3d38.81409925161615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b0f02c6539a9%3A0xacc6091466dd9068!2s901%20N%20Pitt%20St%20Suite%20170%2C%20Alexandria%2C%20VA%2022314%2C%20USA!5e0!3m2!1sen!2sin!4v1745932514329!5m2!1sen!2sin" width={"600"} height={"570"} style={{border:"0px"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>

    )
}

export default Contact
